import { Outlet } from "react-router-dom";
import { useUiStore } from "@/stores/uiStore";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { ConfirmDialog } from "@/components/ConfirmDialog";

export function AppShell() {
  const sidebarCollapsed = useUiStore((s) => s.sidebarCollapsed);
  const setSidebarCollapsed = useUiStore((s) => s.setSidebarCollapsed);
  const confirm = useUiStore((s) => s.confirm);
  const hideConfirm = useUiStore((s) => s.hideConfirm);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggleCollapsed={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>

      <ConfirmDialog
        open={confirm.open}
        title={confirm.title}
        message={confirm.message}
        confirmLabel={confirm.confirmLabel}
        danger={confirm.danger}
        onConfirm={confirm.onConfirm}
        onOpenChange={(open) => {
          if (!open) hideConfirm();
        }}
      />
    </div>
  );
}
